/* DRAFT: enable only after a scoped current-MAIN deployment is reviewed.
 * No cookies, storage, contact fields, Google requests or consent changes.
 * References: shopify.dev/docs/api/customer-privacy and /api/ajax/reference/cart.
 */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.OrganiclesCodAttribution = api;
    if (root.OrganiclesCodAttributionConfig && root.OrganiclesCodAttributionConfig.enabled === true) {
      api.install(root);
    }
  }
})(typeof window !== 'undefined' ? window : {}, function () {
  'use strict';
  var PREFIX = '__organicles_ads_';
  var IDS = ['gclid', 'gbraid', 'wbraid'];
  var META = ['captured_at', 'marketing_consent', 'sharing_consent', 'marketing_allowed', 'sharing_allowed', 'visitor_country', 'source', 'schema'];
  var KEYS = IDS.concat(META).map(function (key) { return PREFIX + key; });
  var HOSTS = ['organicles.pk', 'www.organicles.pk', '0bffe4-df.myshopify.com'];

  function parseClick(href) {
    var url;
    try { url = new URL(href); } catch (_) { return null; }
    if (HOSTS.indexOf(url.hostname) < 0 || url.protocol !== 'https:') return null;
    var ids = {};
    for (var i = 0; i < IDS.length; i++) {
      var key = IDS[i], values = url.searchParams.getAll(key);
      if (!values.length) continue;
      if (values.length !== 1 || !/^[A-Za-z0-9_.-]{10,512}$/.test(values[0])) return null;
      ids[key] = values[0];
    }
    return Object.keys(ids).length ? ids : null;
  }

  function privacyState(shopify) {
    try {
      var privacy = shopify.customerPrivacy;
      if (!privacy || typeof privacy.currentVisitorConsent !== 'function' ||
          typeof privacy.marketingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') {
        return { allowed: false, clear: false, reason: 'PRIVACY_UNAVAILABLE' };
      }
      var consent = privacy.currentVisitorConsent();
      var region = typeof privacy.getRegion === 'function' ? privacy.getRegion() : '';
      var country = typeof region === 'string' && /^[A-Za-z]{2}[A-Za-z0-9]{0,3}$/.test(region) ? region.slice(0, 2).toUpperCase() : '';
      var marketingAllowed = privacy.marketingAllowed() === true;
      var sharingAllowed = privacy.saleOfDataAllowed() === true;
      return {
        // Shopify Allowed methods include merchant region settings; blank choice
        // can coexist with allowed processing. Never turn blank into "yes".
        allowed: consent.marketing !== 'no' && consent.sale_of_data !== 'no' && marketingAllowed && sharingAllowed,
        clear: consent.marketing === 'no' || consent.sale_of_data === 'no' || !marketingAllowed || !sharingAllowed,
        marketingChoice: consent.marketing === 'yes' ? 'yes' : consent.marketing === 'no' ? 'no' : 'unset',
        sharingChoice: consent.sale_of_data === 'yes' ? 'yes' : consent.sale_of_data === 'no' ? 'no' : 'unset',
        visitorCountry: country,
        reason: marketingAllowed && sharingAllowed ? 'PROCESSING_ALLOWED' : 'NOT_ALLOWED'
      };
    } catch (_) { return { allowed: false, clear: false, reason: 'PRIVACY_ERROR' }; }
  }

  function attributes(ids, timestamp, marketingChoice, sharingChoice, visitorCountry) {
    var result = {};
    KEYS.forEach(function (key) { result[key] = ''; });
    if (ids) {
      Object.keys(ids).forEach(function (key) { result[PREFIX + key] = ids[key]; });
      result[PREFIX + 'captured_at'] = timestamp;
      result[PREFIX + 'marketing_consent'] = marketingChoice === 'yes' ? 'yes' : 'unset';
      result[PREFIX + 'sharing_consent'] = sharingChoice === 'yes' ? 'yes' : 'unset';
      result[PREFIX + 'visitor_country'] = /^[A-Z]{2}$/.test(visitorCountry || '') ? visitorCountry : '';
      result[PREFIX + 'marketing_allowed'] = 'true';
      result[PREFIX + 'sharing_allowed'] = 'true';
      result[PREFIX + 'source'] = 'url_query';
      result[PREFIX + 'schema'] = '1';
    }
    return result;
  }

  function install(win) {
    if (!win || !win.document || !win.location || typeof win.fetch !== 'function') return null;
    if (win.__organiclesCodCaptureInstalled) return win.__organiclesCodCaptureInstalled;
    var initial = parseClick(win.location.href);
    var clock = function () { return new Date().toISOString(); };
    var capturedAt = clock();
    var state = { enabled: true, capture: 'PENDING_PRIVACY', write: 'NOT_ATTEMPTED' };
    var chain = Promise.resolve(), saved = false, cleared = false, savedChoice = null;
    var shopify = win.Shopify || {};
    var cartRoot = (shopify.routes || {}).root || '/';
    if (typeof cartRoot !== 'string' || cartRoot[0] !== '/' || cartRoot.indexOf('//') >= 0) {
      state.capture = 'INVALID_CART_ROUTE'; return state;
    }
    var endpoint;
    try { endpoint = new URL(cartRoot + 'cart/update.js', win.location.href); } catch (_) { return state; }
    if (endpoint.origin !== new URL(win.location.href).origin || HOSTS.indexOf(endpoint.hostname) < 0) {
      state.capture = 'INVALID_HOST'; return state;
    }

    function schedule() {
      chain = chain.then(async function () {
        var consent = privacyState(win.Shopify || {});
        var clearing = consent.clear;
        var metadataChoice = [consent.marketingChoice, consent.sharingChoice, consent.visitorCountry].join('|');
        if (clearing && cleared) return;
        if (!clearing && (!consent.allowed || !initial || (saved && savedChoice === metadataChoice))) {
          state.capture = !consent.allowed ? consent.reason : !initial ? 'NO_VALID_CLICK' : 'CAPTURED';
          return;
        }
        // No cart quantity, notes, existing attributes or customer fields are sent.
        var payload = { attributes: attributes(clearing ? null : initial, capturedAt, consent.marketingChoice, consent.sharingChoice, consent.visitorCountry) };
        try {
          var response = await win.fetch(endpoint.pathname, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!response.ok) throw new Error('CART_ATTRIBUTE_SAVE_FAILED');
          state.write = 'HTTP_OK_PERSISTENCE_NOT_ADMIN_VERIFIED';
          if (clearing) { cleared = true; saved = false; savedChoice = null; state.capture = 'CLEARED'; }
          else {
            saved = true; cleared = false; savedChoice = metadataChoice; state.capture = 'CAPTURED';
            // If permission changed during POST, queue a same-origin deletion.
            if (privacyState(win.Shopify || {}).clear) schedule();
          }
        } catch (_) { state.write = 'FAILED'; state.capture = 'NOT_PERSISTED'; }
      });
      return chain;
    }
    win.document.addEventListener('visitorConsentCollected', schedule);
    var handle = { state: state, flush: function () { return chain; } };
    win.__organiclesCodCaptureInstalled = handle;
    if (win.Shopify && win.Shopify.customerPrivacy) schedule();
    else if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) state.capture = 'PRIVACY_LOAD_FAILED';
        else schedule();
      });
    } else state.capture = 'PRIVACY_UNAVAILABLE';
    return handle;
  }
  return { parseClick: parseClick, privacyState: privacyState, attributes: attributes, install: install, keys: KEYS.slice() };
});
